// extracted by mini-css-extract-plugin
module.exports = {"description-list":"DescriptionList_description-list__3o46J","descriptionList":"DescriptionList_description-list__3o46J","title":"DescriptionList_title__cwcMZ"};